module.exports = __webpack_public_path__ + "static/media/cartao-exemplo2.1858dc77.png";